import React, { ReactElement } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { Typography } from "@material-ui/core";
import { InvoiceEditNoteDialog } from "./InvoiceEditNoteDialog";
import colors from "../../constants/colors";

interface InvoiceFileSetNoteSectionProps {
	//The note for the invoice file set.
	note: string;
	//The callback method for setting a new note for the invoice file set.
	setNote: (newNote: string) => void;
	//The callback method for setting the dialog contents.
	setDialogContents: (title: string, element: ReactElement | undefined) => void;
}

const useStyles = makeStyles((theme) => ({
	button: {
		marginLeft: theme.spacing(2),
		marginTop: 5,
		marginBottom: 5,
		float: "right",
		width: 120,
	},
}));

/**
 * This component is used for displaying the note section of an invoice history database record.
 * @param props
 */
export const InvoiceFileSetNoteSection = (props: InvoiceFileSetNoteSectionProps) => {
	const classes = useStyles();
	const [expanded, setExpanded] = React.useState(false);

	return (
		<div style={{ marginLeft: 10 }}>
			<Typography style={{ marginBottom: 10, marginTop: 10, fontWeight: "bold" }}>Note</Typography>
			<div style={{ display: "flex" }}>
				<div
					style={{
						backgroundColor: colors.gray100,
						padding: 5,
						paddingTop: 2,
						width: 600,
						maxHeight: expanded ? 300 : 80,
						overflow: expanded ? "auto" : "hidden",
						border: "1px solid",
						borderColor: colors.gray300,
						boxShadow: "-1px 1px 1px gray",
						borderRadius: 5,
					}}
					data-testid={"invoice-note-display"}
				>
					{props.note.length > 225 && !expanded ? (
						<Typography>{props.note.slice(0, 225) + "..."}</Typography>
					) : (
						<Typography>{props.note}</Typography>
					)}
				</div>
				<div
					style={{
						height: 80,
						margin: "auto",
						whiteSpace: "nowrap",
						width: 120,
						marginLeft: 100,
						justifySelf: "flex-end",
					}}
				>
					{props.note.length > 225 && (
						<Button
							size="small"
							variant="outlined"
							color={"primary"}
							onClick={() => setExpanded(!expanded)}
							className={classes.button}
							data-testid="expand-note-button"
						>
							{expanded ? "Collapse Note" : "Expand Note"}
						</Button>
					)}

					<Button
						size="small"
						variant="outlined"
						color={"primary"}
						onClick={() => {
							props.setDialogContents(
								"Invoice Note",
								<InvoiceEditNoteDialog setNote={props.setNote} note={props.note}></InvoiceEditNoteDialog>,
							);
						}}
						className={classes.button}
						data-testid="edit-note-button"
					>
						{"Edit Note"}
					</Button>
				</div>
			</div>
		</div>
	);
};
